var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "gestao-usuario" },
    [
      _vm.showTree
        ? _c("TreeModal", { attrs: { items: _vm.tree, spec: _vm.modalDim } })
        : _vm._e(),
      _c("div", { staticClass: "gestao-topo" }, [
        _c(
          "div",
          { staticClass: "title" },
          [
            _c(
              "v-btn",
              { attrs: { color: "primary" }, on: { click: _vm.showUserTree } },
              [_vm._v("Carteira")]
            )
          ],
          1
        ),
        _c("div", { staticClass: "carteiras-usuarios" }, [
          _vm._m(0),
          _c("div", { staticClass: "info-carteira" }, [
            _c("span", { staticClass: "title-carteira" }, [
              _vm._v(
                " " + _vm._s(_vm.totalUsuarios) + "/" + _vm._s(_vm.maxUsers)
              )
            ]),
            _c("span", { staticClass: "descricao-carteira" }, [
              _vm._v("Carteira/Usuários")
            ])
          ])
        ])
      ]),
      _c(
        "v-card",
        { attrs: { width: "100vw" } },
        [
          _c(
            "v-container",
            {
              staticClass: "container",
              attrs: { fluid: "", "fill-height": "" }
            },
            [
              _c(
                "v-row",
                { staticClass: "top", attrs: { justify: "space-between" } },
                [
                  _c("v-col", { attrs: { cols: "12", sm: "6", md: "3" } }, [
                    _c("span", { staticClass: "title-usuarios" }, [
                      _vm._v("Usuários")
                    ])
                  ]),
                  _c(
                    "v-col",
                    {
                      staticClass: "col-2 coluna-input",
                      attrs: { cols: "12", sm: "6", md: "3" }
                    },
                    [
                      _c(
                        "v-tooltip",
                        {
                          attrs: { bottom: "", color: "blue" },
                          scopedSlots: _vm._u([
                            {
                              key: "activator",
                              fn: function(ref) {
                                var on = ref.on
                                var attrs = ref.attrs
                                return [
                                  _c(
                                    "v-btn",
                                    _vm._g(
                                      _vm._b(
                                        {
                                          staticClass: "tooltip",
                                          attrs: {
                                            icon: "",
                                            id: "novoUsuario"
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.showModal(
                                                "novoUsuario",
                                                $event
                                              )
                                            }
                                          }
                                        },
                                        "v-btn",
                                        attrs,
                                        false
                                      ),
                                      on
                                    ),
                                    [
                                      _c("img", {
                                        staticClass: "icon",
                                        attrs: {
                                          src: require("@/assets/icons/add_circle_icon.svg"),
                                          alt: "dashboard"
                                        }
                                      })
                                    ]
                                  )
                                ]
                              }
                            }
                          ])
                        },
                        [_c("span", [_vm._v("Novo usuário")])]
                      ),
                      _c("v-text-field", {
                        attrs: {
                          placeholder: "Pesquisar",
                          outlined: "",
                          rounded: "",
                          dense: "",
                          "prepend-inner-icon": "mdi-magnify"
                        },
                        model: {
                          value: _vm.searchUser,
                          callback: function($$v) {
                            _vm.searchUser = $$v
                          },
                          expression: "searchUser"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c("v-data-table", {
                staticClass: "elevation-1",
                attrs: {
                  headers: _vm.headers,
                  items: _vm.desserts,
                  "custom-filter": _vm.filterUser,
                  search: _vm.searchUser
                },
                on: {
                  "click:row": function($event) {
                    return _vm.handleClick($event)
                  }
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "item.name",
                      fn: function(ref) {
                        var item = ref.item
                        return [
                          _c("div", { staticClass: "profile" }, [
                            _c("div", { staticClass: "name-profile" }, [
                              _c("span", [_vm._v(_vm._s(item.name))])
                            ])
                          ])
                        ]
                      }
                    },
                    {
                      key: "item.email",
                      fn: function(ref) {
                        var item = ref.item
                        return [
                          _c("div", { staticClass: "profile" }, [
                            _c("div", { staticClass: "name-profile" }, [
                              _c("span", [_vm._v(_vm._s(item.email))])
                            ])
                          ])
                        ]
                      }
                    },
                    {
                      key: "item.phoneNumber",
                      fn: function(ref) {
                        var item = ref.item
                        return [
                          _c("div", { staticClass: "profile" }, [
                            _c("div", { staticClass: "name-profile" }, [
                              _c("span", [_vm._v(_vm._s(item.phoneNumber))])
                            ])
                          ])
                        ]
                      }
                    },
                    {
                      key: "item.created_at",
                      fn: function(ref) {
                        var item = ref.item
                        return [
                          _c("div", { staticClass: "profile" }, [
                            _c("div", { staticClass: "name-profile" }, [
                              _c("span", [
                                _vm._v(_vm._s(_vm.formatDate(item.created_at)))
                              ])
                            ])
                          ])
                        ]
                      }
                    },
                    {
                      key: "item.actions",
                      fn: function(ref) {
                        var item = ref.item
                        return [
                          _c(
                            "div",
                            { staticClass: "slot-btns" },
                            [
                              _c("v-img", {
                                staticClass: "btn-icon",
                                attrs: {
                                  src: require("@/assets/icons/edit_icon.svg")
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.showModal(
                                      "editarUsuario",
                                      $event,
                                      item
                                    )
                                  }
                                }
                              }),
                              _c("v-img", {
                                staticClass: "btn-icon",
                                attrs: {
                                  src: require("@/assets/icons/delete_outline_icon.svg")
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.deletItem(item)
                                  }
                                }
                              })
                            ],
                            1
                          )
                        ]
                      }
                    },
                    {
                      key: "top",
                      fn: function() {
                        return [
                          _c(
                            "v-dialog",
                            {
                              attrs: { "max-width": "500px" },
                              model: {
                                value: _vm.dialogDelete,
                                callback: function($$v) {
                                  _vm.dialogDelete = $$v
                                },
                                expression: "dialogDelete"
                              }
                            },
                            [
                              _c(
                                "v-card",
                                { staticClass: "card-dialog" },
                                [
                                  _c(
                                    "v-card-title",
                                    { staticClass: "text-h5" },
                                    [_c("span", [_vm._v("Deletar usuário?")])]
                                  ),
                                  _c(
                                    "v-card-text",
                                    { staticClass: "descricao-dialog" },
                                    [
                                      _vm._v(
                                        " Isso irá apagar permanentemente todas as informações e transações anteriormente cadastradas "
                                      )
                                    ]
                                  ),
                                  _c(
                                    "v-card-actions",
                                    [
                                      _c("v-spacer"),
                                      _c(
                                        "v-btn",
                                        {
                                          staticClass: "btn-cancel-dialog",
                                          attrs: {
                                            color: "blue darken-1",
                                            text: ""
                                          },
                                          on: { click: _vm.closeDelete }
                                        },
                                        [_c("span", [_vm._v("Cancelar")])]
                                      ),
                                      _c(
                                        "v-btn",
                                        {
                                          staticClass: "btn-delete-dialog",
                                          attrs: {
                                            color: "blue darken-1",
                                            text: ""
                                          },
                                          on: { click: _vm.deleteUsuario }
                                        },
                                        [_c("span", [_vm._v("Deletar")])]
                                      ),
                                      _c("v-spacer")
                                    ],
                                    1
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "btn-close-dialog",
                                      on: { click: _vm.closeDialog }
                                    },
                                    [
                                      _c("v-img", {
                                        attrs: {
                                          src: require("@/assets/icons/clear_icon.svg")
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ]
                      },
                      proxy: true
                    },
                    {
                      key: "no-data",
                      fn: function() {
                        return [
                          _c(
                            "v-btn",
                            {
                              staticClass: "btn-tentar-de-novo",
                              attrs: { color: "error" }
                            },
                            [_vm._v(" Nenhum usuário encontrado ")]
                          )
                        ]
                      },
                      proxy: true
                    }
                  ],
                  null,
                  true
                )
              })
            ],
            1
          )
        ],
        1
      ),
      (_vm.totalUsuarios > 1000000
      ? (_vm.dialog = true)
      : (_vm.dialog = false))
        ? _c(
            "v-dialog",
            {
              attrs: { width: "500" },
              model: {
                value: _vm.dialog,
                callback: function($$v) {
                  _vm.dialog = $$v
                },
                expression: "dialog"
              }
            },
            [
              _c(
                "v-card",
                { staticClass: "card-dialog-plano" },
                [
                  _c("div", { staticClass: "img-notification" }, [
                    _c("img", {
                      attrs: {
                        src: require("../../../assets/icons/notification_icon.svg")
                      }
                    })
                  ]),
                  _c(
                    "v-card-title",
                    { staticClass: "text-h5 title-limite-plano" },
                    [
                      _vm._v(
                        " Você atingiu o limite de carteiras do seu plano! "
                      )
                    ]
                  ),
                  _c("v-card-text", [
                    _vm._v(
                      " Para continuar cadastrando novas carteiras, dê um upgrade no seu plano. "
                    )
                  ]),
                  _c(
                    "v-card-actions",
                    [
                      _c("v-spacer"),
                      _c(
                        "v-btn",
                        {
                          staticClass: "btn-gerenciar-plano",
                          attrs: { text: "" },
                          on: {
                            click: function($event) {
                              _vm.dialog = false
                            }
                          }
                        },
                        [_vm._v(" Gerenciar Plano ")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "icon-carteira" }, [
      _c("figure", [
        _c("img", {
          attrs: { src: require("@/assets/icons/wallet_icon.svg"), alt: "" }
        })
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }